import { Flex } from "@chakra-ui/react";

import {
  CircularBackground,
  ContainRow,
  DateMonth,
  DateText,
  DayHeader,
  InfoWrapper,
  LunarText,
  LunarWrapper,
  Text,
  Wrapper,
} from "../style";
import formatLuna from "../../../../utils/formatLuna";
import COLOR from "../../../../constant/COLOR";
import useResponsive from "../../../../hooks/useResponsive";

interface SectionProps {
  detailCalendar: any;
}
const Section1: React.FC<SectionProps> = ({ detailCalendar }) => {
  const { isMobile } = useResponsive();

  return (
    <Wrapper>
      <InfoWrapper>
        <CircularBackground>
          <Flex direction="column" alignItems="center">
            <DayHeader>
              {" "}
              {detailCalendar?.weekday
                ? formatLuna[detailCalendar.weekday.toLowerCase()]
                : ""}
            </DayHeader>
            <DateText>{`${detailCalendar.daySolar}`}</DateText>
            <DateMonth>{`Tháng ${detailCalendar.monthSolar}, ${detailCalendar.yearSolar} `}</DateMonth>
            <Text>(Dương lịch)</Text>
          </Flex>
        </CircularBackground>
        <LunarWrapper>
          <LunarText>{`Ngày ${detailCalendar.dayLunar} tháng ${detailCalendar.monthLunar}`}</LunarText>
          <Text>(Âm lịch)</Text>
        </LunarWrapper>
        <Text
          style={{
            fontWeight: 600,
            fontSize: isMobile ? "13px" : "28px",
            color: COLOR.gray900,
            textAlign: "center",
          }}
        >
          Trực{" "}
          <span style={{ color: COLOR.accent500 }}>
            {formatLuna[detailCalendar.truc.toLowerCase()]}
          </span>
          , Tú{" "}
          <span style={{ color: COLOR.accent500 }}>
            {formatLuna[detailCalendar?.tu.toLowerCase()]}
          </span>
          , Tiết{" "}
          <span style={{ color: COLOR.accent500 }}>
            {formatLuna[detailCalendar?.tiet.toLowerCase()]}
          </span>
        </Text>
        {detailCalendar.isHoangDaoDay ? (
          <ContainRow>
            <Text
              style={{
                color: COLOR.primary10,
                transform: "scale(3) translateY(-2px)",
              }}
            >
              &sdot;
            </Text>
            <Text
              style={{
                color: COLOR.primary900,
                fontWeight: 500,
              }}
            >
              Ngày hoàng đạo
            </Text>
          </ContainRow>
        ) : (
          <ContainRow>
            <Text
              style={{
                color: COLOR.primary900,
                transform: "scale(3) translateY(-2px)",
              }}
            >
              &sdot;
            </Text>
            <Text
              style={{
                color: COLOR.primary900,
                fontWeight: 500,
              }}
            >
              Ngày hắc đạo
            </Text>
          </ContainRow>
        )}
        {detailCalendar.bachKy.length > 0 && (
          <ContainRow
            style={{
              alignItems: "start",
              gap: 0,
            }}
          >
            <Text
              style={{
                color: COLOR.gray10,
              }}
            >
              *
            </Text>
            <Text
              style={{
                color: COLOR.gray10,
                fontWeight: 600,
                fontSize: isMobile ? "13px" : "28px",
                textAlign: "center",
              }}
            >
              Bách kỵ:{" "}
              {detailCalendar.bachKy.map((item: any, idx: any) => (
                <span
                  key={idx}
                  style={{
                    color: COLOR.accent600,
                  }}
                >
                  {formatLuna[item] || item}
                  {idx < detailCalendar.bachKy.length - 1 && ", "}
                </span>
              ))}
            </Text>
          </ContainRow>
        )}
      </InfoWrapper>
    </Wrapper>
  );
};

export default Section1;
